<template>
	<div class="jiangli">
		<div class="jiangli_top">
			<img @click="fanhui()" src="../../assets/images/licai/fanhui.png"/>
			<p class="">常见问题</p>
		</div>
		<div class="jiangli_con">
			<div class="jiangli_con_cnt">
				<h4>如何成为富达集团用户？</h4>
				<p class="">在富达集团平台注册账号，即可成为富达集团用户。</p>
				<h4>如何注册账号？</h4>
				<p class="">打开App，进入登陆页，点击“注册”页面，根据页面提示信息填写注册信息，即可完成注册。</p>
				<h4> 收不到验证码该如何处理？</h4>
				<p class="">1）确认短信是否被手机软件拦截或过滤。</p>
				<p class="">2）确认手机是否能正常接收短信（信号问题、欠费、停机等）。</p>
				<p class="">3）短信收发过程中可能会有延时，请耐心等候。</p>
				<p class="">4）您可联系富达集团在线客服进行咨询。</p>
				<h4> 注册成功后手机号码可以修改吗</h4>
			    <p class=""> 手机号码作为用户名登陆注册成功后不可修改。</p>
				
				<h4> 账户能否注销？</h4>
				<p class="">富达集团暂不支持账户注销，但可以清空账户资料，请联系在线客服，富达集团恪守承诺，将全力保护用户信息安全。</p>
				
				<h4> 富达集团账户密码分几种？</h4>
				<p class="">1）账户密码有登陆密码、交易密码两种，登陆密码用于登陆账户使用，交易密码在资金发生变化（建仓或提现）时使用。</p>
				<p class="">2）注册后交易密码默认为初次登陆密码，为了您的账户安全，请定期更换交易密码与登陆密码，并确保登陆密码设置与交易密码不同。</p>
				
				
				<h4> 	如何修改登陆密码？</h4>
				<p class="">在富达集团我的页面点击 【 安全中心 】 ，点击登陆密码或交易密码，系统自动跳转至新页面，输入当前帐号所绑定的手机号码，输入验证码，点击 【 下一步 】 ，获取短信校验码输入并提交，即可重新收到短信新的登陆密码和支付密码。</p>
				
				<h4> 手机丢失影响账户安全性么？</h4>
				<p class="">登陆富达集团账户以后，打开“我的”页面，点击 【 安全中心 】 ，找到“修改登陆密码”，输入相应信息，即可完成登陆密码的修改。</p>
				
				<h4> 如何修改交易密码？</h4>
				<p class="">登陆富达集团账户以后，打开“我的”页面，点击 【 安全中心 】 ，找到“修改支付密码”，输入相应信息，即可完成交易密码的修改。</p>
				
				<h4> 为什么要进行实名认证？</h4>
				<p class="">1 ）为了提高账户安全等级，保障资金的安全性和合同的有效性，富达集团要求在首次提现前完成通过实名身份认证，安全认证的过程简单便捷，富达集团承诺对所有个人资料均作严格保密。</p>
				<p class="">2 ）实名登记时，如果身份证号里含有 x ，直接填写 x , 不区分大小写。</p>
				
				<h4> 如何申请开通网上银行？</h4>
				<p class="">目前所有的商业银行都支持个人网银业务，您只需要携带有效身份证件，到当地您所持银行卡的发卡行任意营业网点，即可申请开通网上银行业务。</p>
				
				<h4> 为何需要绑定银行卡？</h4>
				<p class="">绑定银行卡的目的是用于资金提现，因此绑定银行卡的账号信息必须与实名认证的信息一致。绑定时请仔细填写“账号”、“开户银行”、所属“分行”及“支行（或分理处）”名称，核对无误后提交。如果无法确定开户行的信息，请提前致电银行卡所属银行进行咨询。如果信息填写不规范，您的提现申请有可能被银行退回。</p>
				<p class="">温馨提示：请提供申请提现的银行卡账号，并确保该账号的开户人姓名和您在富达集团上提供的身份证上的真实姓名一致，否则无法成功提现。</p>
				
				<h4> 帐号能否绑定信用卡？</h4>
				<p class="">资金绑定所用银行卡仅限储蓄卡，不支持信用卡。</p>
				
				<h4 class="">帐号绑定银行卡的数量？</h4>
				
				<p>富达集团支持多张银行卡的绑定。</p>
				
				<h4 class="">能否更改绑定银行卡？</h4>
				
				<p>在平台我的一银行卡绑定一可以自行删除与新增银行卡。</p>
				
				<h4 class="">更改过绑定银行卡，提现资金会到哪张卡？</h4>
				
				<p>用户提现成功后，资金会进入到提现时所选的银行卡。</p>
				
				<h4 class="">如何对账户充值？</h4>
				
				<p>登陆账号后，点击［充值］会跳转到客服中心，联系平台在线客服，备注需要充值的用户名，即可完成充值。</p>
				<h4 class="">充值会收手续费吗？</h4>
				
				<p>充值产生的费用由第三方支付公司收取，平台不收取任何手续费。</p>
				
				<h4 class="">充值后多久到账？</h4>
				
				<p>充值成功后会即时到账，如果您通过银行确认已经成功支付，但账号没有显示您的充值记录，您可联系在线客服进行咨询。</p>
				
				<h4 class="">账户对每日的充值限额有要求吗？</h4>
				
				<p>每日支付限额由银行每日支付限额、第三方支付平台每日支付限额和用户对银行卡设定的支付限额所决定，限额取三者最小值。详情可登陆各银行官网或拨打银行客服电话进行查询。</p>
				
				<h4 class="">是否能用多个银行卡对同一个账户进行充值？</h4>
				
				<p>可以。可分别用不同的银行卡进行充值，也可以帮其他用户充值，联系在线客服即可</p>。
				
				<h4 class="">如何查询充值记录？</h4>
				
				<p>用户登陆平台后，进入 【 个人中心】一 【 财务明细 】 页面，即可在列表中看到所有的充值记录。</p>
				
				<h4 class="">充值成功，账户余额却没有增加，怎么办？</h4>
				
				<p>如果您通过银行确认已经成功支付，但账户余额却没有增加，您可联系在线客服务进行咨询。</p>
				
				<h4 class="">能否用信用卡充值？</h4>
				
				<p>暂不支持银行信用卡充值，限制由第三方支付平台和银行设定的支持充值所决定，详情可登陆各银行官网或拨打银行客服电话进行查询。</p>
				
				<h4 class="">如何申请提现？</h4>
				
				<p>1）用户登陆平台账号后，（为保证提现成功处理，点击 【 提现 】 ，选择银行卡请提前绑定银行卡），输入提现金额和交易密码，点击 【 确定 】 ，提现申请即可成功提交。</p>
				
				<p>2）您可以随时将您在平台的可用余额申请提现到您现有的任何一家银行的账号上。</p>
				
				<h4 class="">账户提现需手续费吗？</h4>
				
				<p>平台不收取任何手续费用。</p>
				
				<h4 class="">提现后多久可以到账？</h4>
				
				<p>1）申请提现时间为：每日 09 : 00 一 22 : 00 ，提现申请成功提交后，平台将于 24 小时内提现到银行卡，正常情况 2 小时即可到账（具体情形依据银行卡所属银行规则而定）。</p>
				
				<p>2）夜间 22 : 00 一次日 08 : 59 前提现申请成功提交后，当日工作时间处理（具体情形依据银行卡所属银行规则而定）。</p>
				
				<h4 class="">提现失败怎么回事？</h4>
				
				<p>1）检查提现绑定的银行卡姓名是否与身份认证的姓名一致。</p>
				
				<p>2）银行开户行信息错误。</p>
				
				<p>3）银行账号／户名错误，或是账号和户名不符。</p>
				
				<p>4）使用信用卡提现。</p>
				
				<p>5）银行账户冻结或正在办理挂失。 注：如果遇到以上情况，我们会在收到支付机构转账失败的通知后解除您的资金冻结，请您不必担心资金安全。</p>
				
				<h4 class="">提现支持其他人的银行卡吗？</h4>
				
				<p>为保障您的账户资金安全，只可向注册人本人名下的银行卡提现，否则提现申请将不予受理。</p>
				
				<h4 class="">富达集团是否对投资人收取费用？</h4>
				
				<p>富达集团于用户不会收取任何费用。</p>
				
				<h4 class="">建仓前需要注意哪些事项？</h4>
				
				<p>1）请详细阅读所选择产品的日化回报率、持仓周期等信息。</p>
				
				<p>2）确保账户的金额充足，如若不够请及时充值。</p>
				
				<p>3）确认自己将要建仓的金额，并核对所选产品剩余金额是否满足自己建仓所需。</p>
				
				<h4 class="">建仓后何时开始计算收益？</h4>
				
				<p>当天认购建仓，当天开始计算股权回报收益，次日 0 点开始结算当天收益。</p>
				
				<h4 class="">什么样的投资方式适合我？</h4>
				
				<p>由于每位投资者对投资收益和资金流动性的要求不一，富达集团专门推出不同的产品，在您对所有产品比较之后，根据自己的需要，确定投资方案。</p>
				
				<h4 class="">有没有最低投标金额限制？</h4>
				
				<p>项目不同，建仓金额也不一样，具体要参照项目详情介绍。</p>
				
				<h4 class="">什么时候可以投资？</h4>
				
				<p>未满仓的情况下，都可以建仓。富达集团将陆续发布新的产品，敬请留意。</p>
				<h4 class="">持仓到期资金何时进入账户？</h4>
				
				<p>持仓期限到期当天，持仓金额与项目收益即可返还到用户的平台账户中，可以进行再次建仓或申请出资提现。</p>
				
				<h4 class="">建仓后是否可以取消？</h4>
				
				<p>建仓后不允许取消。持仓期结束后持仓金额和项目收益即可返还到用户的平台账户中，可以进行再次建仓或申请提现。</p>
				
				<h4 class="">持仓期限到期后可以马上提现吗？</h4>
				
				<p>持仓期限到期当天，持仓金额与项目收益即可返还到用户的平台账户中，可以进行再次建仓或申请出资提现。</p>
				
				<h4 class="">如何查看交易记录？</h4>
				
				<p>登陆平台帐号以后，进入到“我的”页面，可以查看到财务明细。</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "ProBlem",
		data: function() {
			return {
				types:0,
			};
		},
		created() {
	
		},
		mounted: function() {
			
		},
		methods: {
			fanhui:function(){
				this.$router.push({
					path:'/'
				})
			}
		},
	};
</script>
<style>
	h4{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 43px;
		opacity: 0.99;
	}
	.jiangli_con_cnt p{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 28px;
		opacity: 0.99;
	}
	.jiangli_con{padding: 30px 15px;}
	.jiangli_top{
		width: 100%;
		height: 45px;
		line-height: 45px;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.jiangli_top img{
		height: 30px;
		width: 30px;
		position: absolute;left: 0px;
	}
	.jiangli_top p{
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		text-align: center;
	}
</style>
